import { TaskEither } from "fp-ts/TaskEither"
import { taskEitherExt as TEx } from "@ssc-booking/functional-support"
import * as GenericError from "@ssc-booking/functional-support/src/generic-error"
import * as F from "fp-ts/function"
import * as TE from "fp-ts/TaskEither"

// TODO: handle timeouts and set timeout

const fetchTE = (input: RequestInfo, init?: RequestInit) =>
    TEx.tryCatchGenericError(
        () => fetch(input, init),
        `Unable to fetch from ${typeof input === "string" ? input : input.url}`,
    )
const fetchSuccess = (input: RequestInfo, init?: RequestInit) =>
    F.pipe(
        fetchTE(input, init),
        TE.chain(
            TE.fromPredicate(
                (response) => response.ok,
                (response) =>
                    GenericError.fatal(
                        `Unable to fetch from ${typeof input === "string" ? input : input.url}`,
                        undefined,
                        {
                            statusCode: response.status,
                        },
                    ),
            ),
        ),
    )

const json = (response: Response): TaskEither<GenericError.GenericError, unknown> =>
    TEx.tryCatchGenericError(() => response.json(), `Unable to parse Json from ${response.url}`)

export const getJson = (url: string): TaskEither<GenericError.GenericError, unknown> =>
    F.pipe(fetchSuccess(url), TE.chain(json))
